import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ImageComponent from '../../../components/common/Image';

const Header = ({ searchTerm, setSearchTerm, showSearchModal, setShowSearchModal }) => {

    const href = "#";
    const navigate = useNavigate();

    const handleBackNavigation = (e) => {
        e.preventDefault();
        navigate('/dashboard');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate('/dashboard');
        }
    };

    const handleSearchModalKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setShowSearchModal(true);
        }
    };

    return (
        <div className="position-relative ">
            <header className="sticky-top rounded-0">
                <div className="container-fluid topNav-dash">
                    <div className="web-header">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center tablet-content">
                                <a href={href}>
                                    <ImageComponent fileName="cholacd.svg" alt="cholacd" style={{ height: "40px" }} className="img-fluid" />
                                </a>
                                <h6 className="Pname">CD</h6>
                            </div>
                        </div>
                    </div>

                    <div className="mob-header">
                        <div>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="text-white fs-6 d-flex py-2 mt-2 align-items-center gap-1">
                                    <button
                                        className="icon-arrowleftl1 fs-2 btn p-0 border-0 bg-transparent text-white"
                                        onClick={handleBackNavigation}
                                        onKeyDown={handleKeyDown}
                                        tabIndex="0"
                                        role="button"
                                        aria-label="Go back to dashboard"
                                        style={{ cursor: 'pointer' }}
                                    ></button> EMI Calculator
                                </div>
                            </div>
                        </div>

                        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample"
                            aria-labelledby="offcanvasExampleLabel">
                            <div className="offcanvas-header">
                                <ImageComponent fileName="chola_logo 1.svg" alt="chola_logo 1" />
                                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body">
                                <div>

                                </div>
                            </div>
                            <div className="footer">
                                <div id="#userProfile" className='d-none'>

                                    <div className="dp rounded-circle">RK</div>
                                    <div className="name">
                                        Hi, Ravi Kumar<br />
                                        1233@gmail.com: <span className="text-white">Sree Rajee</span>
                                    </div>

                                    <ul className="dropdown-menu text-small">
                                        <li>
                                            <a className="dropdown-item" href={href}>New project...</a>
                                        </li>
                                        <li><a className="dropdown-item" href={href}>Settings</a></li>
                                        <li><a className="dropdown-item" href={href}>Profile</a></li>
                                        <li>
                                            <hr className="dropdown-divider" />
                                        </li>
                                        <li><a className="dropdown-item" href={href}>Sign out</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </header>
        </div>
    )
}

Header.propTypes = {
    searchTerm: PropTypes.string.isRequired,
    setSearchTerm: PropTypes.func.isRequired,
    showSearchModal: PropTypes.bool.isRequired,
    setShowSearchModal: PropTypes.func.isRequired
};

export default Header